import { useState } from "react";
import { throwResponseError } from "../../../../utils/api-error-utils";
import { getAuthParams, hasValue } from "../../../../utils/pacto-rebates-utils";
import { formatLatePaymentPenaltyPayload, formatLatePaymentPenaltyResponse, validateLatePaymentPenaltyPayload } from "../../../utils/late-payment-penalty-utils";

export function useLatePaymentPenalty() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    const validateLatePaymentPenalty = values => {
        const errors = validateLatePaymentPenaltyPayload(values);

        setValidationErrors(errors);

        return errors;
    };

    async function createLatePaymentPenalty(payloadData) {
        const errors = validateLatePaymentPenalty(payloadData);

        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            setError(null);

            return {
                ok: false,
                reason: "validation",
                validationErrors: errors
            };
        }

        try {
            setLoading(true);
            setError(null);
            setValidationErrors({});

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const body = formatLatePaymentPenaltyPayload(payloadData);

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                },
                body: JSON.stringify(body)
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/penalidades-inadimplencia`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível salvar a penalidade por inadimplência."
                );
            }

            const data = await response.json();

            const latePaymentPenaltyData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedLatePaymentPenalty = formatLatePaymentPenaltyResponse(latePaymentPenaltyData);

            return {
                ok: true,
                latePaymentPenalty: formattedLatePaymentPenalty
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        validationErrors,
        validateLatePaymentPenalty,
        createLatePaymentPenalty
    };
}